<!-- @format -->
@if (reviewsSEOServer() && isBot) {
	@if (reviewSummary$ | async; as reviewSummary) {
		<div
			class="hmf-display-none"
			itemscope
			itemprop="aggregateRating"
			itemtype="https://schema.org/AggregateRating">
			@if (productReviewed$ | async; as productReviewed) {
				<div
					itemprop="itemReviewed"
					itemscope="true"
					itemtype="https://schema.org/IndividualProduct">
					<span itemprop="name">{{ productReviewed.name }}</span>
				</div>
			}
			<span itemprop="ratingValue">{{ reviewSummary.averageRating | number: '1.0-1' }}</span> out
			of <span itemprop="bestRating">{{ reviewSummary.overallRatingRange }}</span> stars -
			<span itemprop="reviewCount">{{ reviewSummary.reviewCount }}</span> votes
		</div>
	}
}
